import axios from "axios";
import d from "debug";
import { Analytics } from "../analytics/analytics";

const debug = d("cs.LogOut");

export default function logOut(redirect = true): Promise<void> {
  debug("logOut");
  return axios
    .post("/api/auth/logout")
    .then((response) => {
      Analytics.logout().then(() => {
        debug("Logged out, redirecting to Home", response);
        if (redirect) {
          window.location.href = "/";
        }
      });
    })
    .catch((error) => {
      debug(error);
    });
}
